import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const ThinScrollArea = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  paddingTop: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(3),
  '&::-webkit-scrollbar': {
    width: 8,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: alpha(theme.palette.common.black, 0.2),
    borderRadius: theme.shape.borderRadius,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: alpha(theme.palette.common.black, 0.3),
  },
}));
